import React, {useState} from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import TopupForm from "../../../PageUserDashboard/TopupForm"

/* ACTIONS */
import { doTopUp } from '../../../../actions/topUpAction';

/* ASSETS */
import WarningSign from "../../../../images/warning-orange.png";

const WarningSignIcon: any = WarningSign

type InfoInsuficientBalanceProps = {
  topUp: any
  remainingPayment: number
  topup: (payload: any) => void
}

const InfoInsuficientBalance: React.FC<InfoInsuficientBalanceProps> = ({
  remainingPayment,
  ...props
}): JSX.Element => {
  const [modalTopup, setModalTopup] = useState(false)
  return (
    <div className="info-insuficient-balance">
      <KickImage src={WarningSignIcon} alt="..." />
      <div className="insuficient-balance-text">
        <p>Insuficient balance</p>
        <p>
          <span onClick={() => setModalTopup(!modalTopup)}>Top up</span>
        </p>
      </div>

      <TopupForm
        isOpen={modalTopup}
        onToggle={() => setModalTopup(!modalTopup)}
        onSubmit={(payload) => props.topup(payload)}
        dataTopUp={props.topUp}
      />
    </div>
  )
}

const mapStateToProps = ({
  dataTopUp: { pengisian, topUp },
}) => ({ pengisian, topUp })

const mapDispatchToProps = dispatch => ({
  topup: (payload) => dispatch(doTopUp(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InfoInsuficientBalance)